// extracted by mini-css-extract-plugin
module.exports = {"Head":"__06-Benefits_Head__AoWgR","ItemList":"__06-Benefits_ItemList___P8er","Item":"__06-Benefits_Item__YGlxd"};